import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'picturefill';

import './image.scss';
